import Model from '@/models/Model.js';

export default class ChatExcerpt extends Model {
    static entity = 'chat_excerpts';

    static fields() {
        return {
            id: this.attr(null),
            meeting_id: this.attr(null),
            meeting_recording_id: this.attr(null),
            time: this.attr(null),
            name: this.attr(null),
            content: this.attr(null),

            ...super.fields(),

            meeting: this.belongsTo('meetings', 'meeting_id'),
            meeting_recording: this.belongsTo('meeting_recordings', 'meeting_recording_id'),
        };
    }

    get seconds() {
        const [hours, minutes, seconds] = this.time.split(':');

        return Number.parseInt(hours, 10) * 3600 + Number.parseInt(minutes, 10) * 60 + Number.parseInt(seconds, 10);
    }
}
